<template>
  <div class="line">
    <span class="title">{{title}}正答率的趋势</span>
    <el-popover
      placement="top"
      title="说明"
      width="200"
      trigger="hover"
      content="此图表仅展示至少有1名学生完成的测评数据"
      v-if="!fromType"
      >
      <img slot="reference"
      src="../../images/why-icon.png" class="tooltip" alt="">
    </el-popover>
    <el-popover
      placement="top"
      title="说明"
      width="200"
      trigger="hover"
      content="此图表仅展示至少有1名学生完成的练习数据"
      v-else
      >
      <img slot="reference"
      src="../../images/why-icon.png" class="tooltip" alt="">
    </el-popover>
    <header class="line-header" ref="header">
      <ul class="line-header__subject">
        <li
          v-for="(item, index) in subjectList"
          :key="index"
          class="pointer"
          :class="{'isactive': item.active}"
          @click="subjectChange(index)"
        >
          {{item.subject_name}}
        </li>
      </ul>
    </header>
    <div ref="chart" @click="jumpDetil($event)" class="line-chart"></div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { openTab } from '@/utils';

export default {
  name: 'TestLine',
  props: {
    title: {
      default: '测评',
      type: String,
    },
    accuaryTrend: {
      default: () => [],
      type: Array,
    },
    classId: {
      default: '',
      type: String,
    },
    fromType: {},
    startDate: {},
  },
  data() {
    return {
      subjectList: [{
        subject_id: 0,
        subject_name: '全部',
        active: true,
      }],
      subjectId: 0,
      dataList: [],
      evaluateId: '',
      schoolId: '',
      batchId: '',
      type: '',
    };
  },
  watch: {
    startDate() {
      this.subjectList = [{
        subject_id: 0,
        subject_name: '全部',
        active: true,
      }];
    },
    classId() {
      this.subjectList = [{
        subject_id: 0,
        subject_name: '全部',
        active: true,
      }];
    },
    accuaryTrend: {
      immediate: true,
      handler() {
        let arr = [];
        this.accuaryTrend.forEach((item) => {
          arr = [
            ...arr,
            {
              subject_name: item.subject_name,
              subject_id: item.subject_id,
              active: false,
            }];
        });
        arr = this.unique(arr);
        this.subjectList = [
          ...this.subjectList,
          ...arr,
        ];
        this.init();
      },
    },
    subjectId() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    subjectChange(index) { // 切换学科
      this.subjectList.forEach((item) => {
        this.$set(item, 'active', false);
      });
      this.$set(this.subjectList[index], 'active', true);
      this.subjectId = this.subjectList[index].subject_id;
    },
    unique(arr) { // 数组去重
      const res = new Map();
      return arr.filter((item) => !res.has(item.subject_id) && res.set(item.subject_id, 1));
    },
    jumpDetil(e) { // 折线图提示框内跳转
      if (e.target && e.target.nodeName === 'P') {
        let url;
        if (!this.fromType) {
          url = `${window.location.origin}/pt/class-report?evaluateId=${this.evaluateId}&schoolId=${this.schoolId}&classId=${this.classId}&batchId=${this.batchId}&fromType=${this.type}`;
        } else {
          url = `${window.location.origin}/pt/teacher-report?evaluateId=${this.evaluateId}&schoolId=${this.schoolId}&classId=${this.classId}&batchId=${this.batchId}&fromType=${this.type}`;
        }
        openTab(url);
      }
    },
    init() { // 折线图渲染
      if (this.subjectId === 0) {
        this.dataList = this.accuaryTrend;
      } else {
        this.dataList = this.accuaryTrend.filter((kitem) => kitem.subject_id === this.subjectId);
      }
      this.chart = this.$echarts.init(this.$refs.chart);
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          position(point) {
            // 固定在顶部
            return [point[0], '10%'];
          },
          enterable: true, // 鼠标可以进入
          // triggerOn: 'click',
          formatter: (params) => {
            const title = params[0].axisValue;
            const testName = this.dataList[params[0].dataIndex].evaluate_name;
            const subjectName = this.dataList[params[0].dataIndex].subject_name;
            const completeNum = this.dataList[params[0].dataIndex].complete_num;
            const finishCnt = this.dataList[params[0].dataIndex].finish_cnt;
            const avgAccuary = params[0].value;
            this.evaluateId = this.dataList[params[0].dataIndex].evaluate_id;
            this.schoolId = this.dataList[params[0].dataIndex].school_id;
            this.batchId = this.dataList[params[0].dataIndex].batch_id;
            this.type = this.dataList[params[0].dataIndex].type;
            let htmlStr = '<div>';
            if (!this.fromType) {
              htmlStr += `<div>${title} 发布</div><br/>`;
              htmlStr += `<div>《${testName}》</div><br/>`;
              htmlStr += `<div>测试学科: ${subjectName}</div><br/>`;
              htmlStr += `<div>测试完成人数: ${completeNum}</div><br/>`;
              htmlStr += `<div>班级平均正答率: ${avgAccuary}%</div><br/>`;
              htmlStr += '<p style="color:#1890FF">查看报告 >></p><br/>';
              htmlStr += '</div>';
            } else {
              htmlStr += `<div>${title} 发布</div><br/>`;
              htmlStr += `<div>《${testName}》</div><br/>`;
              htmlStr += `<div>题量: ${completeNum}</div><br/>`;
              htmlStr += `<div>完成人数: ${finishCnt}</div><br/>`;
              htmlStr += `<div>班级平均正答率: ${avgAccuary}%</div><br/>`;
              htmlStr += '<p style="color:#1890FF;cursor: pointer">查看报告 >></p><br/>';
              htmlStr += '</div>';
            }
            return htmlStr;
          },
        },
        grid: {
          left: '0',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
        },
        legend: {
          data: [{
            name: '班级平均正答率',
            icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIqADAAQAAAABAAAAIAAAAAB4uvI0AAAEYElEQVRYCcVXW2hcVRRd5840Jo1N60ex8yAFUQOCKaYRBfthsZ8FP2pKVCwtVFpi0tQfMYKWakULfiTj1HaURqwgNOmXICjFx4eCIgWNWGqQ1kemU1GsfcQkbeZu174z5+bOK73TOno+cvbeZz/WWXefcybAfzCSY9JyrTLOtRz+jfX5HPYn03LfYrkaDqTjsCyDYGs+j8yDn0q0FpiGA7l0GVtYfJkI1kx+h6f/NyAC9Nniros9sbSstnpwbigjiRFZTybuChRslTzSAd0XGwrEBZ7yK1lBsDE2LJusaueGAUkelATZeNgWMgYfWpnziNfEAUPDgLhXsIN17Cn5pKUZvTA4p7XZN4mLl7AvgAOLAlmdkZiImGBAGHltRpbwszxpfY2DA6d3mAuOg93WRjD9sRFZa/VFgczNYiiZQo91DjvnZrGJ216l/txFtuNuvK/y2QFzlPpHKnM49HmzZ0wiBcWzVf7Ra9kInuDO9i12EVVGetQvNKmDQ5+tN/PWb0kT+ghmRnWy0vV5Dv0q12TEzaGXjivYcHf8MIHt6hxmJIelkzHrPF+Dq80u3grG/dJnTpOml4q2eX745SrXBiJes3n+TPxCPCNLi8GLTnmzcGTJ6LEzu81v5QHxZrzmGLwTjaDr3C7zoq5XbcREStbkXXwTTMDj91xu0LwStJXLt2Vk+d8zyNLeqmtOBOvYF1+U+1XTqzJCBvTolQ7BM+1vyC2lxlJtZhZbafFAEPi3YUFolgognUeklQ36uC7qIGV/6qz9cuUqnlW52igec/9dYeCBan61bBVA/jiPR1m1TQO4q1PiLLDDbz6gN2a1ZIkRbCCTd3prBhdWrsB71fxq2SqAlHwWgwyb6RgBfa0JyEpLfg57qiVj9/tHloDfnthipqv51bKVAImnpYvFutWZxWcjS3FEZToN6ayD69sSaSnsvGBCfETaad/oqQbiRHGwuBR6KgHCJzrYpONT243XH9lB8zGBHS9mjbp5vBysQBA7idC7IdlTx7P9ZjK4Hkb2gehryISP2SC+DxkrF+chNiBdyIrgkdjr4jF3e0puosm/8PRdKfrXNflALk4ThODmYvT35UePd8gJro3b7OLiVZWnXfQQ2EqVydrPD9yKD1Sud/hACML/LLz1ytnw8kYieJ5C4d0QPBRPyYaSJgUOjW82+XpBqL8HZNWw3Mtd3aMGfZCa2vCuyuVDvz13PWrtjDnMDdyvOu1zrqF+ncMDwiQ+G2yCoz9tM3/Vyhd1sFfB6jqBtAf8xnjUfw/odYkOm62NCXttVKSySe2SN/86YM4SbKrESIWf7bqa1OZxLgNJMnLKMxhMZHeZL+1irbmpCfvJis8a409M9ZuvavmHsTuk8yRPRDeTdZP2wTBB/E1xnsfUOzXqT1A3xEYxR5jSlT76C47/0/7I67w5EkdyarPx+qbSM5xl4fiG8/e9tDCZ2EsmR28UhCa1P/f9AvUIHZ0YPTNZuMzqiavm+w+Gm06BJkbpagAAAABJRU5ErkJggg==',
          }],
          left: '85%',
          itemWidth: 12,
          itemHeight: 12,
        },
        xAxis: {
          type: 'category',
          name: '发布时间',
          data: this.dataList.map((item) => `${dayjs(item.date * 1000).month() + 1}月${dayjs(item.date * 1000).date()}日`),
          axisLine: { // 不显示轴线
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          name: '正答率',
          nameTextStyle: { // name样式修改
            align: 'center',
            color: '#C5C3DE',
            padding: [0, 0, 12, -18],
          },
          splitLine: { // 网格线
            lineStyle: {
              type: 'dashed', // 设置网格线类型 dotted：虚线 solid:实线
              width: 1,
            },
            show: true, // 隐藏或显示
          },
          min: 0,
          max: 100,
        },
        series: [{
          name: '班级平均正答率',
          symbolSize: 10,
          data: this.dataList.map((item) => item.avg_accuary.toFixed()),
          type: 'line',
        }],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  margin-bottom: 30px;
  .tooltip{
    width: 16px;
    height: 16px;
    vertical-align:text-bottom;
  }
  .title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 100%;
        height: 13px;
        background: rgba(60, 194, 230, 0.18);
        border-radius: 7px;
        left: 0;
        bottom: 3px;
      }
   }
  &-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 42px;
    &__subject {
      display: flex;
      height: 40px;
      font-size: 14px;
      padding: 2px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 40px;
      background: #F0F2F5;
      border-radius: 4px;
      li {
        width: 90px;
        text-align: center;
        &:hover {
          color: #1989FA;
        }
      }
    }
    .isactive {
      background-color: #FFFFFF;
      color: #1989FA;
      border-radius: 2px;

    }
  }
  &-chart {
    height: 440px;
    // width: 100vw;
  }
}

</style>
